import {
  type ConfigurationPackage,
  OpenAPI as ConfigurationOpenAPI,
} from '@festina/configuration-general-types/configuration'
import { useMutation } from '@tanstack/react-query'

export const useMutateConvertConfigurationPackageToParameterValuesCsv = () =>
  useMutation({
    mutationFn: async (configurationPackage: ConfigurationPackage) => {
      if (!ConfigurationOpenAPI.BASE) {
        throw new Error('The configuration service has not been configured')
      }

      const conversionUrl = `${ConfigurationOpenAPI.BASE}/conversion/parameters/convert-to-format`
      const serverToken = ConfigurationOpenAPI.TOKEN

      const headers = new Headers()

      if (serverToken) {
        const token =
          typeof serverToken === 'string'
            ? serverToken
            : await serverToken({
                method: 'POST',
                url: conversionUrl,
              })

        headers.append('authorization', `Bearer ${token}`)

        // headers.append('accept', 'application/octet-stream')
        headers.append('Content-Type', 'application/json')
      }

      const request: RequestInit = {
        headers,
        body: JSON.stringify(configurationPackage),
        method: 'POST',
      }

      const response = await fetch(conversionUrl, request)

      if (!response.ok) {
        const json = await response.json()
        throw new Error(JSON.stringify(json, null, 2))
      }

      return await response.blob()
    },
  })
